import React, { useState } from "react";
import HeaderThree from "../../../components/header/HeaderThree";
import { Helmet } from "react-helmet";

import estate from "../../../assets/Core-icons/Industires-we-work-with/Real-Estate-software.svg";
import education from "../../../assets/Core-icons/Industires-we-work-with/Education.svg";
import Ecommerce from "../../../assets/Core-icons/Industires-we-work-with/E-commerce-software.svg";
import game from "../../../assets/Core-icons/Industires-we-work-with/Games.svg";
import fitness from "../../../assets/Core-icons/Industires-we-work-with/Fitness-software.svg";
import health from "../../../assets/Core-icons/Industires-we-work-with/Healthcare.svg";
import demand from "../../../assets/Core-icons/Industires-we-work-with/On-demand.svg";
import grocery from "../../../assets/Core-icons/Industires-we-work-with/Grocery.svg";
import Industriescopy2 from "../../../assets/Sub-component/Industriescopy2";
import CoreComponent25 from "../../../assets/Sub-component/CoreComponent25";
import CoreComponent26 from "../../../assets/Sub-component/CoreComponent26";
import CoreComponent27 from "../../../assets/Sub-component/CoreComponent27";
import CoreComponent28 from "../../../assets/Sub-component/CoreComponent28";

import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import { Link, useNavigate } from "react-router-dom";

import Client_Collaboration from "../../../assets/Services/Techgropse_Offers/Client_Collaboration.svg";
import Deployment from "../../../assets/Services/Techgropse_Offers/Deployment.svg";
import Development from "../../../assets/Services/Techgropse_Offers/Development.svg";
import Planning_and_Design from "../../../assets/Services/Techgropse_Offers/Planning_and_Design.svg";
import Requirement_Analysis from "../../../assets/Services/Techgropse_Offers/Requirement_Analysis.svg";
import Testing_and_Quality from "../../../assets/Services/Techgropse_Offers/Testing_and_Quality.svg";

import Competitive_Advantage from "../../../assets/Services/Benefits_of_Custom_Software_Development/Competitive_Advantage.svg";
import Cost_Effective from "../../../assets/Services/Benefits_of_Custom_Software_Development/Cost_Effective.svg";
import Efficiency from "../../../assets/Services/Benefits_of_Custom_Software_Development/Efficiency.svg";
import Enhanced_Security from "../../../assets/Services/Benefits_of_Custom_Software_Development/Enhanced_Security.svg";
import Flexibility from "../../../assets/Services/Benefits_of_Custom_Software_Development/Flexibility.svg";
import Scalability from "../../../assets/Services/Benefits_of_Custom_Software_Development/Scalability.svg";
import Tailored_to_Your_Needs from "../../../assets/Services/Benefits_of_Custom_Software_Development/Tailored_to_Your_Needs.svg";

import Agriculture from "../../../assets/Services/Angular_dev/angular_industries/Agriculture.svg";
import Elearning from "../../../assets/Services/Angular_dev/angular_industries/Elearning.svg";
import Entertainment from "../../../assets/Services/Angular_dev/angular_industries/Entertainment.svg";
import Financial from "../../../assets/Services/Angular_dev/angular_industries/Financial.svg";
import Fitness from "../../../assets/Services/Angular_dev/angular_industries/Fitness.svg";
import IOT from "../../../assets/Services/Angular_dev/angular_industries/IOT.svg";
import Real_Estate from "../../../assets/Services/Angular_dev/angular_industries/Real_Estate.svg";

import BPM from "../../../assets/Services/Angular_dev/solution/BPM.svg";
import CHATBOT from "../../../assets/Services/Angular_dev/solution/CHATBOT.svg";
import CRM from "../../../assets/Services/Angular_dev/solution/CRM.svg";
import EDM from "../../../assets/Services/Angular_dev/solution/EDM.svg";
import EMR from "../../../assets/Services/Angular_dev/solution/EMR.svg";
import ERP from "../../../assets/Services/Angular_dev/solution/ERP.svg";
import LMS from "../../../assets/Services/Angular_dev/solution/LMS.svg";
import Social from "../../../assets/Services/Angular_dev/solution/Social.svg";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";

const SoftwareDevelopment = () => {
  const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const content = [
    {
      icon: Entertainment,
      title: "Entertainment",
      class: "border-bottom",
      class2: "border-end",
    },
    {
      icon: Elearning,
      title: "Elearning",
      class2: "border-end",
      class: "border-bottom",
    },
    {
      icon: estate,
      title: "Real Estate",
      class: "border-bottom",
      class2: "border-end",
    },

    {
      icon: Ecommerce,
      title: "Ecommerce",
      class: "border-bottom",
      class2: "border-end",
    },
    {
      icon: game,
      title: "Gaming",
      class: "border-end",
      class2: "border-bottom",
    },
    {
      icon: health,
      title: "Healthcare",
      class2: "border-end",
      class: "border-bottom",
    },

    {
      icon: grocery,
      title: "Grocery",
      class2: "border-end",
      class: "border-bottom",
    },
    {
      icon: Fitness,
      title: "Fitness Center",
      class: "border-bottom",
    },
    {
      icon: Financial,
      title: "Financial",
      class2: "border-end",
    },
    {
      icon: Agriculture,
      title: "Agriculture",
      class2: "border-end",
    },
    {
      icon: fitness,
      title: "Fitness",
      class2: "border-end",
    },
    {
      icon: IOT,
      title: "IoT",
    },
  ];
  const content2 = [
    {
      icon: CHATBOT,
      title: "CHATBOT ",
      class: "border-bottom",
      class2: "border-end",
    },
    {
      icon: EMR,
      title: "EHR/EMR ",
      class: "border-bottom",
      class2: "border-end",
    },
    {
      icon: BPM,
      title: " BPM ",
      class: "border-bottom",
      class2: "border-end",
    },
    {
      icon: Social,
      title: " SOCIAL ",
      class: "border-bottom",
      class2: "border-end",
    },
    {
      icon: ERP,
      title: " ERP ",
      class: "border-end",
      // class2: "border-end",
    },
    {
      icon: CRM,
      title: "CRM ",
      class: "border-end",
    },
    {
      icon: EDM,
      title: "EDM",
      class2: "border-end",
      // class: "border-bottom",
    },
    {
      icon: LMS,
      title: "LMS",
      class2: "border-end",
      // class: "border-bottom",
    },
  ];
  const header = [
    {
      title: " Full Stack Developers ",
      num: "50+",
    },
    {
      title: " Blockchain Developers ",
      num: "20+",
    },
    {
      title: " Digital Solution ",
      num: "200+",
    },
    {
      title: "Clients ",
      num: "750+",
    },
  ];
  const header2 = [
    {
      title: " Projects delivered  ",
      num: "35+",
    },
    {
      title: " countries served ",
      num: "7+",
    },
    {
      title: "years of experience  ",
      num: "10+",
    },
  ];

  const softwareinner = {
    title: "The Strategic Edge of Custom Software",
    childer: [
      {
        title:
          "The main goals of custom software development are to satisfy your needs and business goals and set your business apart from the competition in the online marketplace. ",
      },
      {
        title:
          "We collaborate and offer guidance at every stage of the process, from designing, creating, and implementing applications that meet your company's requirements. Our proactive software uses efficient tools to automate manual tasks, saving time and effort. We provide solutions that improve your growth level for your business.You can fully control your features and future course by incorporating this software development into your company. ",
      },
      {
        title:
          "These can maintain your business data efficiently through improved data management and the insights for generating an actionable performance for making better-informed decisions. Completely extensive custom software development helps to build a top-prioritized and client-based technological fit for your business for optimized functionality and steady competitive position upkeep.",
      },
      // {
      //   title:
      //     "",
      // },
    ],
  };

  const softwareinner2 = {
    title: "Experience Raiden’s Custom software Development",
    childer: [
      {
        title:
          "Raiden provides customized software development for various business sectors to showcase their unique facilities in an advanced and functioning way. We communicate with our clients frequently, ask about their needs, and aim for positive business upkeep. Our leadership approach tends to provide relevant solutions to your complex problems with a 100% satisfactory rate. The agile development approach and commitment towards the business and its users make them one of the leading software development companies in this digital space. Our tech stack expertise enhances your business by advancing your security, transparency, and decentralized models for transactions, digital assets, and complete customer engagement, which gradually navigate your business to reach future innovation. Reach a wide range of audiences and make them valuable customers by showcasing this customized software development. Every feature, every functionality, and every specification of the system is precisely made based on your complete requirements and demands. We provide you with valuable suggestions so that you can expertise your ideation for a meaningful deployment and success. We keep your business's future growth in mind and provide efficient software.",
      },
      // {
      //   title:
      //     "Custom software development solutions are used to create unique computer applications or programs tailored to meet the specific needs of an organization, business, or individual.",
      // },
      // {
      //   title:
      //     "Custom software development solutions are used to create unique computer applications or programs tailored to meet the specific needs of an organization, business, or individual.",
      // },
      // {
      //   title:
      //     "Custom software development solutions are used to create unique computer applications or programs tailored to meet the specific needs of an organization, business, or individual.",
      // },
    ],
  };

  const softwarebenifitbox = [
    {
      icon: Tailored_to_Your_Needs,
      title: "Tailoring your needs",
      desc: "Obtain what you require with our strategic goal, positive approach, and workflows that guarantee your company reaches a higher level.",
      class: "true",
    },
    {
      icon: Flexibility,
      title: " Unmatched Adaptability ",
      desc: "  We craft solutions that modify and incorporate new features and ensure your software stands unique, effective, and engaged with the future value for the business. ",
      class: "true",
    },
    {
      icon: Efficiency,
      title: " Enhanced Efficiency in Operations ",
      desc: "  We focus on more advanced tools to meet your needs and automate your tasks efficiently. Customized software facilitates your business and simplifies your op. ",
      class: "true",
    },
    {
      icon: Enhanced_Security,
      title: "  Fortifies Security",
      desc: "We create software with highly encrypted security protocols and customized solutions to meet your company's needs.    ",
      class: "true",
    },
    {
      icon: Cost_Effective,
      title: " Cost-effective over time ",
      desc: " Creating software that meets your needs may incur software development cost, but the cost of regular maintenance and updates will gradually drop if you invest a long time.  ",
      class: "true",
    },
    {
      icon: Competitive_Advantage,
      title: " Competitive Edge ",
      desc: "Raiden excels in providing an optimistic business approach, advanced features, and efficient functionalities to stand unique in your competitive space.  ",
      class: "true",
    },
    {
      icon: Scalability,
      title: " Scalability  ",
      desc: " Raiden is known for its proficient skills and professional developers who craft custom software development for any company and have a desire to maintain, support, and update their data and features even after delivery.   ",
      class: "true",
    },
  ];

  const DifferenceBox = {
    title: "Custom Software Development:",
    child: [
      {
        title: "Tailoring your needs:",
        desc: "Achieve your goals with our strategic approach and workflows that elevate your company.",
      },
      {
        title: "  Unmatched Adaptability:",
        desc: "Elevate your company and achieve your goals with our strategic approach.  ",
      },
      {
        title: "Advanced Operational Efficiency : ",
        desc: " We use advanced, effective tools that enhance your overall functionality and optimize your business processes. ",
      },
      {
        title: "  Scalability:  ",
        desc: "  Build custom software that furnishes your business in an optimized way and stands unique among other competitors in this evolving digital space.",
      },
    ],
  };

  const DifferenceBox2 = {
    title: "Off-the-shelf software ",
    child: [
      {
        title: "Immediate Availability:",
        desc: " You can make immediate investments, downloads, and deployments, minimizing the development time.",
      },
      {
        title: "  Lower Upfront Cost:",
        desc: " The cost is much lower at first, and licensing fees are used to distribute the development costs among many.",
      },
      {
        title: " Community & Support :",
        desc: " A variety of online communities, forums, and vendor support for best practices are available to you.",
      },
      {
        title: " Reduced Risk :",
        desc: "Reduced the chance of causing unpredictable development complications or project delays. ",
      },
    ],
  };

  const card = [
    {
      title: "Precision & Clarity  ",
      icon: Requirement_Analysis,
      desc: "  We deeply understand your unique needs and build a product that meets your vision and business purpose.   ",
    },
    {
      title: " Planning & Design ",
      icon: Planning_and_Design,
      desc: "  We create an efficient performance for your business by efficiently strategizing your performance, security, and future-focused approach.  ",
    },
    {
      title: " Expert craftsmanship ",
      icon: Development,
      desc: "Raiden's skilled developers create a realistic view of your ideas and build for superior performance.    ",
    },
    {
      title: "Testing & Quality Assurance  ",
      icon: Testing_and_Quality,
      desc: "We undergo various rigorous testing programs that identify and destroy any issues or bugs for a productive performance.    ",
    },
    {
      title: " Client collaboration",
      icon: Client_Collaboration,
      desc: "   Our specialty is your vision; by working together, we keep lines of communication open and continuously evaluate feedback to maximize performance.   ",
    },
    {
      title: " Seamless launch & lasting support ",
      icon: Deployment,
      desc: "  We offer assistance with a variety of testing procedures to ensure faultless maintenance, updates, and support.  ",
    },
  ];

  const navigate = useNavigate();

  const nav = () => {
    navigate("/request-quote");
  };
   const handleClick=(e)=>{
    
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    setForm({ name: '', email: '', mobile: '', message: '' }); 
    console.log("data submitted succesfully")
   })
   
  
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <div>
      <div className="main-page-wrapper">
        <Helmet>
          <title>
            Customer Support || Deski-Saas & Software React Template
          </title>
        </Helmet>

        <HeaderThree />
        <div className=" container ">
          <div
            className=" row pb-80 padb d-flex align-items-center"
            style={{ minHeight: "100vh", marginTop: "-35px" }}
          >
            <div className="col-lg-6">
              <h1 className="me-lg-5 mb-3 h1-heading lh-sm">
                Software Development
              </h1>
              <p className="me-lg-5 mb-3  h1-para lh-base">
                At Raiden, with our 10+ years of expertise, we design, build,
                and deploy software applications to deliver you a
                beyond-the-digital experience. Creating innovation across
                various types of industries tends to generate efficiency and
                productivity for your business.
              </p>
              <div className="d-flex ">
                <Link to="/request-quote">
                  <button className="h1-para mt-lg-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
                    Get Your Free Quote
                  </button>
                </Link>
              </div>
            </div>

            <Contact/>
          </div>
        </div>

        <div className="text-center container  overflow-hidden">
          <h2 className="h2-heading lh-sm">
            We focus on offering customized application development services
            across various needs.
          </h2>
          <h3 className="text-start mt-3  text-decoration-underline ps-2 mb-3">
            Industries
          </h3>
          <div className="bg-black text-white  mb-80 marb pt-60 padt padb pb-60 rounded-4">
            <div className="container text-center ">
              <Industriescopy2 content={content} />
            </div>
          </div>
        </div>

        <div className="text-center container  overflow-hidden">
          <h3 className="text-start fs-4 h3-heading lh-base text-decoration-underline ps-2 mb-3">
            Solutions
          </h3>
          <div className="bg-black text-white  mb-80 marb padt padb pt-60 pb-60 rounded-4">
            <div className="container text-center ">
              <Industriescopy2 content={content2} />
            </div>
          </div>
        </div>

        <div className="container mb-80 marb ">
          <CoreComponent25 header={header} />
        </div>

        <div className="container">
          <h2 className="text-center mb-4 pb-lg-2 h2-heading lh-sm  ">
            Why Custom Software is Driving Digital Transformation
          </h2>

          <CoreComponent26 softwareinner={softwareinner} />
        </div>

        <div className="container mt-5">
          <CoreComponent26 softwareinner={softwareinner2} />
        </div>

        <div className="container mt-5 ">
          <h3 className="h3-heading h3-heading ">
            The financial benefits of developing custom software
          </h3>
          <p className="mb-4 pb-2 mt-lg-4 mt-2 h3-para">
            Software development and modification allow you to make sufficient
            space for your business's intended use.
          </p>
          <CoreComponent27 softwarebenifitbox={softwarebenifitbox} />
          <p className="mt-lg-4 mt-3 h1-para">
            As your company's features advance, your software also must be
            updated to maintain your business compatibility and user experience.
          </p>
        </div>

        <div className="container">
          <h2 className="mb-3 h2-heading  lh-base mb-2 mt-80 mart ">
            As your company's features advance, your software also must be
            updated to maintain your business compatibility and user experience.
          </h2>

          <CoreComponent28 DifferenceBox={DifferenceBox} />
          <div className="mt-4">
            <CoreComponent28 DifferenceBox={DifferenceBox2} />
            <p className="mt-lg-4 mt-3 h1-para lh-base  ">
              The main differences between custom software and off-the-shelf
              software are the projects' flexibility and business purpose, both
              of which have the potential to improve the organization in unique
              ways.
            </p>
          </div>
        </div>
        <div className="container mt-80 mart ">
          <h2 className="h2-heading">
            Cost to build custom software development
          </h2>
          <p className="h1-para mt-2 lh-base">
            We at Raiden have over ten years of experience developing software
            solutions, and we write code that creates more than just websites
            for your business.
          </p>
          <Link to="/request-quote">
            <p className="mt-lg-4 mt-3 h1-para lh-base text-decoration-underline cursor">
              Let's get started!
            </p>
          </Link>
        </div>

        <div className="container mt-80 mart ">
          <div className="row bg-black mx-auto  p-lg-5 p-4 rounded-4">
            <div className=" ">
              <h3 className="text-white h3-heading text-center ">
                Swipe up, access your business with best mobile software
                development company
              </h3>
              <div className="d-flex justify-content-center ">
                <button className="h1-para mt-4 btn-gradient text-white rounded-4 px-lg-3 px-2 py-lg-2 py-2 mx-auto mx-lg-0">
                  Get Started today
                </button>
              </div>
            </div>
          </div>

          <div className="mt-80 mart ">
            <h2 className="h2-heading lh-sm ">
              Experience Raiden’s Software Development
            </h2>
            <p className="my-lg-4 my-3 pb-2 h1-para lh-base">
              Choosing Raiden for your software development process is the first
              and best step you can take to increase the efficiency of your
              business.
            </p>
            <CoreComponent25 header={header2} />
            <p className="mt-2  mb-1 pt-2 h1-para lh-base">
              Raiden is one of the prominent software development company across
              the world
            </p>
            <p className="h1-para lh-base  mb-1">
              We maintain our proficiency with low software development cost.
            </p>
            <p className="h1-para ">
              Custom software development efficiently crafts your business
              according to your idea and needs.{" "}
            </p>
          </div>
        </div>

        <div className="container mt-80 mart ">
          <div className="row bg-black mx-auto  p-lg-5 p-4 rounded-4">
            <div className="  justify-content-center text-center">
              <h3 className="text-white h3-heading ">
                Raiden aids for your software development services
              </h3>
              <p className="mt-2 h1-para text-white">
                Increase your business’s potential reach and functionality with
                Raiden’s development team. Hire- design- deploy.
              </p>
              <div className="d-flex justify-content-center">
                <button
                  className="h1-para  mt-3  btn-gradient text-white rounded-4 px-lg-3 px-2 py-lg-2 py-2 mx-auto mx-lg-0"
                  onClick={nav}
                >
                  Let's talk!
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-80 mart  ">
          <h2 className="h2-heading lh-sm ">
            Complete space for software development cycle
          </h2>
          <p className="mt-lg-4 mt-2 mb-4 pb-2 h1-para lh-base">
            {" "}
            Raiden Labs is one of the top celebrated decentralized gaming
            development companies internationally. Our comprehensive development
            framework is crafted to produce sophisticated, pioneering, and
            robust solutions that achieve and transcend client aspirations.
          </p>
          <div className="row">
            {card.map((val, i) => (
              <div key={i} className="col-lg-6 text-center mb-4 ">
                <div className=" border-dark border p-3 mb-4 rounded-4 overflow-hidden d-flex h-100 justify-content-between">
                  <img src={val.icon} alt="" className="icon-logo " />

                  <div className="card-body p-3">
                    <h3 className="fs-5 mb-2 h3-heading lh-sm ">{val.title}</h3>
                    <p className="fs-6 lh-base h3-para ">{val.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <footer className="theme-footer-two pt-80 padt ">
          <div className="top-footer">
            <div className="container">
              <FooterTwo />
            </div>
          </div>
          <div className="container">
            <div className="bottom-footer-content">
              <CopyRightTwo />
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default SoftwareDevelopment;
